export default function displayNumberInHumanReadableFormat(number: number): string {
    try {
        return new Intl.NumberFormat().format(number)
    } catch (error) {
        return 'Invalid value'
    }
}